<template>
    <div>
        <div class="flex gap-4">
            <div>
                <hts-card
                    v-loading="loadingEup"
                    class="w-[300px]">
                    <h2>
                        EUP GPS
                    </h2>
                    <hr >
                    <hts-form-button
                        color="primary"
                        @click="openEdit('eup')">
                        Cập nhật
                    </hts-form-button>
                </hts-card>
            </div>

            <div>
                <hts-card
                    v-loading="loadingBinhAnh"
                    class="w-[300px]">
                    <h2>
                        Bình Anh GPS
                    </h2>
                    <hr >
                    <hts-form-button
                        color="primary"
                        @click="openEdit('binhanh')">
                        Cập nhật
                    </hts-form-button>
                </hts-card>
            </div>
        </div>

        <hts-drawer
            v-model="openEditEup"
            color="main"
            :submit="() => handleSubmit('eup')"
            title="Cập nhật EUP GPS"
            @close="close('eup')">
            <hts-card class="pt-2">
                <hts-form-input
                    v-model="formInputEup.host"
                    label="Host"
                    required />
                <hts-form-input
                    v-model="formInputEup.path"
                    label="Path"
                    required />
                <hts-form-input
                    v-model="formInputEup.consumerId"
                    label="Consumer ID"
                    required />
                <hts-form-input
                    v-model="formInputEup.apiKey"
                    label="API Key"
                    required />
                <hts-form-input
                    v-model="formInputEup.contentType"
                    label="Header - Content Type"
                    required />
            </hts-card>
        </hts-drawer>

        <hts-drawer
            v-model="openEditBinhAnh"
            color="main"
            :submit="() => handleSubmit('binhanh')"
            title="Cập nhật Bình Anh GPS"
            @close="close('binhanh')">
            <hts-card class="pt-2">
                <hts-form-input
                    v-model="formInputBinhAnh.host"
                    label="Host"
                    required />
                <hts-form-input
                    v-model="formInputBinhAnh.pathTracking"
                    label="Path Tracking"
                    required />
                <hts-form-input
                    v-model="formInputBinhAnh.pathRoute"
                    label="Path Route"
                    required />

                <hts-form-input
                    v-model="formInputBinhAnh.customerCode"
                    label="Customer Code"
                    required />
                <hts-form-input
                    v-model="formInputBinhAnh.key"
                    label="Key"
                    required />
                <hts-form-input
                    v-model="formInputBinhAnh.contentType"
                    label="Header - Content Type"
                    disabled />
            </hts-card>
        </hts-drawer>
    </div>
</template>

<script lang="ts" setup>
const { $t } = useNuxtApp()
const loadingEup = ref<boolean>(false)
const loadingBinhAnh = ref<boolean>(false)
const openEditEup = ref<boolean>(false)
const openEditBinhAnh = ref<boolean>(false)

const formInputEup = ref<any>({
  host: 'https://gps-api.eup.net.vn',
  path: '/',
  apiKey: '',
  consumerId: '',
  contentType: 'application/json'
})

const formInputBinhAnh = ref<any>({
  host: 'http://api.gps.binhanh.vn',
  pathTracking: '/api/gps/tracking',
  pathRoute: '/api/gps/route',
  customerCode: '',
  key: '',
  contentType: 'application/json'
})

const openEdit = (type: string) => {
  switch (type) {
  case 'eup':
    openEditEup.value = true
    break
  case 'binhanh':
    openEditBinhAnh.value = true
    break
  }
}

const close = (type: string) => {
  switch (type) {
  case 'eup':
    openEditEup.value = false
    break
  case 'binhanh':
    openEditBinhAnh.value = false
    break
  }
}

const handleSubmit = (type: string) => {
  let formData
  switch (type) {
  case 'eup':
    formData = formInputEup.value
    formData.type = 'eup'
    break
  case 'binhanh':
    formData = formInputBinhAnh.value
    formData.type = 'binhanh'
    break
  default:
    return
  }

  const api = $url.settings.updateGPSSettings

  $api(api, { body: formData })
    .then((data) => {
      if (data?.data.value.success) {
        process.client && $toast().success($t('notifications.updateSuccess'))
      }
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
    })
}

const rules = {
  apiKey: 'required',
  consumerId: 'required'
}

onMounted(() => {
  _initData()
})

const _initData = () => {
  loadingEup.value = true
  loadingBinhAnh.value = true
  const api = $url.settings.getGPSSettings
  $api(api).then((data) => {
    if (!data) {
      return
    }
    const responseData: any = data.data.value

    if (responseData.success) {
      Object.assign(formInputEup.value, responseData.data.eup || {})
      Object.assign(formInputBinhAnh.value, responseData.data.binhanh || {})
      loadingEup.value = false
      loadingBinhAnh.value = false
    }
  })
}
</script>
